export const capitalizeFirstLetter = (text: any) => {
  if (typeof text !== "string") {
    return text;
  }

  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const FULLY_CAPITALIZED_WORDS = [
  "aba", // American Bankers Association (routing number standard)
  "ach", // Automated Clearing House
  "aml", // Anti-Money Laundering
  "apr", // Annual Percentage Rate
  "apy", // Annual Percentage Yield
  "arm", // Adjustable Rate Mortgage
  "bsa", // Bank Secrecy Act
  "cd", // Certificate of Deposit
  "cfpb", // Consumer Financial Protection Bureau
  "cip", // Customer Identification Program
  "cra", // Community Reinvestment Act
  "dca", // Dollar-Cost Averaging
  "dob", // Date of Birth
  "dti", // Debt-to-Income ratio
  "ein", // Employer Identification Number
  "esa", // Education Savings Account
  "fdic", // Federal Deposit Insurance Corporation
  "fsa", // Flexible Savings Account
  "heloc", // Home Equity Line of Credit
  "hoa", // Homeowners Association
  "hsa", // Health Savings Account
  "iban", // International Bank Account Number
  "id", // Identification
  "iolta", // Interest on Lawyer Trust Accounts
  "ira", // Individual Retirement Account
  "itin", // Individual Taxpayer Identification Number
  "kyc", // Know Your Customer
  "llc", // Limited Liability Company
  "llp", // Limited Liability Partnership
  "ltv", // Loan-to-Value ratio
  "ncua", // National Credit Union Administration
  "nsf", // Non-Sufficient Funds
  "ofac", // Office of Foreign Assets Control (sanctions screening)
  "otp", // One-Time Password
  "pdf", // Portable Document Format
  "pin", // Personal Identification Number
  "pmi", // Private Mortgage Insurance
  "ssn", // Social Security Number
  "swift", // Society for Worldwide Interbank Financial Telecommunication
  "tin", // Taxpayer Identification Number
];
